import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children, allowedRoles, requiredOnderzoek }) {
  const { isAuthenticated, isVerifying, user } = useAuth();
  const location = useLocation();
  const roleRestricted = Array.isArray(allowedRoles) && allowedRoles.length > 0;

  if (isVerifying) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roleRestricted) {
    if (!user) {
      return null;
    }

    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (requiredOnderzoek) {
    if (!user) {
      return null;
    }
    if (
      user.role !== "superadmin" &&
      !user.onderzoeken?.includes(requiredOnderzoek)
    ) {
      return <Navigate to="/blog" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
